<template>
  <div class="rules-create">
    <notifications group="create-rule" position="top center" />
    <div class="card">
      <div class="card-header">
        <h3 class="mb-0 text-center">Create Rule</h3>
      </div>
      <div class="card-body">
        IP: {{ $route.params.ip }}
        <b-form @submit.prevent="createrule" id="createrule">
          <loading
            :active.sync="loading"
            :can-cancel="false"
            color="#2196f3"
            :z-index="9"
            :is-full-page="fullPage"
          ></loading>

          <draggable
            v-model="form.blocks"
            handle=".handleBlocks"
            :disabled="form.blocks.length <= 1"
          >
            <transition-group>
              <div
                v-for="(block, i) in form.blocks"
                :key="`block-${i}`"
                class="card mb-5"
              >
                <div
                  class="p-4 card-header d-flex justify-content-between align-items-center"
                >
                  <div class="card-title mb-0">
                    <b-form-input
                      v-model="form.blocks[i].title"
                      type="text"
                      placeholder="Enter title"
                    >
                    </b-form-input>
                  </div>
                  <div class="card-toolbar d-flex">
                    <button
                      class="btn bg-white border-0 mx-3"
                      :aria-expanded="form.blocks[i].visible ? 'true' : 'false'"
                      @click.prevent="
                        form.blocks[i].visible = !form.blocks[i].visible
                      "
                    >
                      <i
                        class="fa text-dark"
                        :class="
                          form.blocks[i].visible
                            ? 'fa-chevron-down'
                            : 'fa-chevron-up'
                        "
                      ></i>
                    </button>
                    <button class="btn bg-white handleBlocks" @click.prevent="">
                      <i class="fa fa-align-justify text-dark"></i>
                    </button>
                  </div>
                </div>
                <b-collapse v-model="form.blocks[i].visible">
                  <div class="card-body">
                    <h5 class="text-primary mb-5">Match:</h5>
                    <draggable
                      v-model="form.blocks[i].match"
                      handle=".handle"
                      :disabled="form.blocks[i].match.length <= 1"
                    >
                      <transition-group>
                        <div
                          class="d-flex"
                          v-for="(match, j) in form.blocks[i].match"
                          :key="'match' + j"
                        >
                          <div class="d-flex align-self-center">
                            <i class="fa fa-align-justify handle"></i>
                          </div>
                          <div class="col-4">
                            <b-form-group label="Condition Name">
                              <b-form-select
                                v-model="form.blocks[i].match[j].condition_name"
                                :options="conditionNames"
                              >
                                <template v-slot:first>
                                  <b-form-select-option value=""
                                    >Select Condition Name</b-form-select-option
                                  >
                                </template></b-form-select
                              >
                              <span
                                v-if="
                                  error[
                                    'rules.' +
                                      i +
                                      '.match.' +
                                      j +
                                      '.condition_name'
                                  ]
                                "
                                class="text-danger"
                              >
                                {{
                                  error[
                                    "rules." +
                                      i +
                                      ".match." +
                                      j +
                                      ".condition_name"
                                  ]
                                }}
                              </span>
                            </b-form-group>
                          </div>
                          <div class="col-4">
                            <b-form-group label="Operator">
                              <b-form-select
                                v-model="form.blocks[i].match[j].operator"
                                :options="operators"
                              >
                                <template v-slot:first>
                                  <b-form-select-option value=""
                                    >Select Operator</b-form-select-option
                                  >
                                </template></b-form-select
                              >
                              <span
                                v-if="
                                  error[
                                    'rules.' + i + '.match.' + j + '.operator'
                                  ]
                                "
                                class="text-danger"
                              >
                                {{
                                  error[
                                    "rules." + i + ".match." + j + ".operator"
                                  ]
                                }}
                              </span>
                            </b-form-group>
                          </div>
                          <div class="col-4">
                            <b-form-group label="Value">
                              <b-form-input
                                v-model="form.blocks[i].match[j].value"
                                type="text"
                              >
                              </b-form-input>
                              <span
                                v-if="
                                  error['rules.' + i + '.match.' + j + '.value']
                                "
                                class="text-danger"
                              >
                                {{
                                  error["rules." + i + ".match." + j + ".value"]
                                }}
                              </span>
                            </b-form-group>
                          </div>
                          <div class="align-self-center">
                            <button
                              class="btn p-0"
                              @click.prevent="removeMatch(i, j)"
                            >
                              <i class="fa fa-times text-danger"></i>
                            </button>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                    <span
                      v-if="error['rules.' + i + '.match']"
                      class="text-danger"
                    >
                      {{ error["rules." + i + ".match"] }}
                    </span>
                    <div class="text-right">
                      <button
                        @click.prevent="addMatch(i)"
                        class="btn btn-default"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                    <h5 class="text-primary mb-5">Deploy:</h5>
                    <draggable
                      v-model="form.blocks[i].deploy"
                      handle=".handle"
                      :disabled="form.blocks[i].deploy.length <= 1"
                    >
                      <transition-group>
                        <div
                          class="d-flex flex-wrap"
                          v-for="(deploy, j) in form.blocks[i].deploy"
                          :key="'deploy' + j"
                        >
                          <div class="align-self-center">
                            <i class="fa fa-align-justify handle"></i>
                          </div>
                          <div class="col">
                            <b-form-group label="Variable Name">
                              <b-form-select
                                v-model="form.blocks[i].deploy[j].variable_name"
                                :options="variable_names"
                                @change="(value) => detectContinue(value, i, j)"
                              >
                                <template v-slot:first>
                                  <b-form-select-option value=""
                                    >Select Variable Name</b-form-select-option
                                  >
                                </template></b-form-select
                              >
                              <span
                                v-if="
                                  error[
                                    'rules.' +
                                      i +
                                      '.deploy.' +
                                      j +
                                      '.variable_name'
                                  ]
                                "
                                class="text-danger"
                              >
                                {{
                                  error[
                                    "rules." +
                                      i +
                                      ".deploy." +
                                      j +
                                      ".variable_name"
                                  ]
                                }}
                              </span>
                            </b-form-group>
                          </div>
                          <div class="col">
                            <b-form-group
                              class="varNameTypes"
                              label="Variable Name Value"
                              :description="
                                form.blocks[i].deploy[j].variable_name ==
                                'continue'
                                  ? 'Please enter true or false'
                                  : ''
                              "
                            >
                              <b-input-group>
                                <b-input-group-prepend is-text>
                                  <b-form-radio-group
                                    id="btn-radios-1"
                                    v-model="
                                      form.blocks[i].deploy[j].varNameType
                                    "
                                    :options="varNameTypes"
                                    name="radios-btn-default"
                                    value-field="value"
                                    text-field="text"
                                    button-variant="outline-primary"
                                    buttons
                                    @change="
                                      (value) => resetValues(value, i, j)
                                    "
                                  ></b-form-radio-group>
                                </b-input-group-prepend>
                                <b-form-select
                                  v-if="
                                    form.blocks[i].deploy[j].varNameType ==
                                    'fun'
                                  "
                                  v-model="
                                    form.blocks[i].deploy[j].variable_name_value
                                  "
                                  :options="functions"
                                  text-field="name"
                                  value-field="value"
                                  @change="(value) => showParams(value, i, j)"
                                >
                                  <template v-slot:first>
                                    <b-form-select-option value=""
                                      >Select Function
                                      Name</b-form-select-option
                                    >
                                  </template></b-form-select
                                >
                                <b-form-input
                                  v-if="
                                    form.blocks[i].deploy[j].varNameType ==
                                    'text'
                                  "
                                  v-model="
                                    form.blocks[i].deploy[j].variable_name_value
                                  "
                                  type="text"
                                  placeholder="Enter Variable Name"
                                >
                                </b-form-input>
                                <span
                                  v-if="
                                    error[
                                      'rules.' +
                                        i +
                                        '.deploy.' +
                                        j +
                                        '.variable_name_value'
                                    ]
                                  "
                                  class="text-danger"
                                >
                                  {{
                                    error[
                                      "rules." +
                                        i +
                                        ".deploy." +
                                        j +
                                        ".variable_name_value"
                                    ]
                                  }}
                                </span>
                              </b-input-group>
                            </b-form-group>
                          </div>
                          <div
                            class="col d-flex"
                            v-if="form.blocks[i].deploy[j].varNameType == 'fun'"
                          >
                            <b-form-group
                              class="varNameTypes"
                              v-for="(param, k) in form.blocks[i].deploy[j]
                                .params"
                              :key="'param' + k"
                              :label="'Parameter ' + (k + 1)"
                            >
                              <b-form-input
                                v-model="form.blocks[i].deploy[j].params[k]"
                                type="text"
                                placeholder="Enter Variable Name"
                              >
                              </b-form-input>
                            </b-form-group>
                          </div>
                          <div class="align-self-center">
                            <button
                              class="btn p-0"
                              @click.prevent="removeDeploy(i, j)"
                            >
                              <i class="fa fa-times text-danger"></i>
                            </button>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                    <span
                      v-if="error['rules.' + i + '.deploy']"
                      class="text-danger"
                    >
                      {{ error["rules." + i + ".deploy"] }}
                    </span>
                    <div class="text-right">
                      <button
                        @click.prevent="addDeploy(i)"
                        class="btn btn-default"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </transition-group>
          </draggable>
        </b-form>
        <span v-if="error.rules" class="small text-danger">{{
          error.rules
        }}</span>
        <div class="text-right">
          <button @click.prevent="addBlock" class="btn btn-default">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="text-center mt-10">
      <button type="submit" form="createrule" class="btn btn-primary">
        Create
      </button>
    </div>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import draggable from "vuedraggable";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import _ from "lodash";
import http from "@/axios";
export default {
  data() {
    return {
      conditionNames: [],
      operators: [
        "equal",
        "!equal",
        "startwith",
        "!startwith",
        "existin_url",
        "!existin_url",
        "between",
        "!between",
      ],
      variable_names: [],
      functions: [
        { name: "func_strip", value: { name: "func_strip", params: 1 } },
        {
          name: "func_do_strip_append",
          value: { name: "func_do_strip_append", params: 2 },
        },
        { name: "func_append", value: { name: "func_append", params: 1 } },
        { name: "url", value: { name: "url", params: 1 } },
      ],
      varNameTypes: [
        { text: "Function", value: "fun" },
        { text: "Text", value: "text" },
      ],
      varNameType: "fun",
      loading: false,
      fullPage: false,
      error: {},
      form: {
        blocks: [
          {
            title: "",
            visible: true,
            match: [{ condition_name: "", operator: "", value: "" }],
            deploy: [
              {
                variable_name: "",
                variable_name_value: "",
                varNameType: "fun",
                params: [],
              },
            ],
          },
        ],
      },
    };
  },
  components: {
    draggable,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "IP Profiles", route: "ip-profiles/all" },
      { title: "Create IP Profile Rule" },
    ]);
  },
  async created() {
    this.getVariableNames();
    this.getConditionNames();
  },
  methods: {
    async getVariableNames() {
      this.loading = true;

      try {
        const res = await http.get("/sbc/variables/deploy");
        this.variable_names = res.data.data.map(({ name, key }) => ({
          text: name,
          value: key,
        }));
        this.loading = false;
      } catch (error) {
        this.$notify({
          group: "settings",
          title: error.response.data.message,
          type: "error",
        });
        this.loading = false;
      }
    },
    async getConditionNames() {
      this.loading = true;

      try {
        const res = await http.get("/sbc/variables/match");
        this.conditionNames = res.data.data.map(({ name, key }) => ({
          text: name,
          value: key,
        }));
        this.loading = false;
      } catch (error) {
        this.$notify({
          group: "settings",
          title: error.response.data.message,
          type: "error",
        });
        this.loading = false;
      }
    },
    removeMatch(i, j) {
      this.form.blocks[i].match.splice(j, 1);
    },
    removeDeploy(i, j) {
      this.form.blocks[i].deploy.splice(j, 1);
    },
    async createrule() {
      this.loading = true;
      let payload = JSON.parse(JSON.stringify(this.form.blocks));
      for (let i = 0; i < payload.length; i++) {
        for (let j = 0; j < payload[i].deploy.length; j++) {
          if (
            payload[i].deploy[j].varNameType == "fun" &&
            payload[i].deploy[j].variable_name_value
          ) {
            payload[i].deploy[j].variable_name_value = `${
              payload[i].deploy[j].variable_name_value.name
            }(${payload[i].deploy[j].params.join(",")})`;
          }
        }
      }
      delete payload.visible;
      payload.forEach(function (p) {
        if (p.deploy.length) {
          p.deploy.forEach(function (d) {
            delete d.params;
            delete d.varNameType;
          });
        }
      });
      await http
        .post(`sbc/ips/rules/${this.$route.params.id}`, { rules: payload })
        .then((res) => {
          this.loading = false;
          this.$notify({
            group: "create-rule",
            title: res.data.message,
            type: "success",
          });
          this.$router.push({ name: "all-ip-profiles" });
        })
        .catch((err) => {
          this.error = err.response.data.error;
          if (err.response.data.message) {
            this.$notify({
              group: "rules",
              title: err.response.data.message,
              type: "error",
            });
          }
          this.loading = false;
        });
    },
    resetValues(value, i, j) {
      this.form.blocks[i].deploy[j].variable_name_value = "";
      this.form.blocks[i].deploy[j].params = [];
    },
    addBlock() {
      this.form.blocks.push({
        title: "",
        visible: true,
        match: [{ condition_name: "", operator: "", value: "" }],
        deploy: [
          { variable_name: "", variable_name_value: "", varNameType: "fun" },
        ],
      });
    },
    addMatch(i) {
      this.form.blocks[i].match.push({
        condition_name: "",
        operator: "",
        value: "",
      });
    },
    detectContinue(value, i, j) {
      if (value == "continue" || value == "rtp_server") {
        this.form.blocks[i].deploy[j].varNameType = "text";
        this.resetValues(value, i, j);
      }
    },
    showParams(value, i, j) {
      this.form.blocks[i].deploy[j].params = [];
      this.form.blocks[i].deploy[j].params.push("");
      if (value.params > 1) {
        this.form.blocks[i].deploy[j].params = _.fill(Array(value.params), "");
        this.$forceUpdate();
      }
      this.$forceUpdate();
    },

    addDeploy(i) {
      this.form.blocks[i].deploy.push({
        variable_name: "",
        variable_name_value: "",
        varNameType: "fun",
      });
    },
  },
};
</script>

<style lang="scss">
.handle,
.handleBlocks {
  cursor: move;
}
.varNameTypes {
  .input-group-text {
    padding: 0 !important;
    background-color: #fff !important;
  }
  .custom-select,
  input[type="text"] {
    height: 40px;
  }
  .btn.btn-outline-primary {
    color: #111;
    background-color: transparent;
    border-color: #f3f6f9;
    border-radius: 0;
  }
  .btn.btn-outline-primary:not(:disabled):not(.disabled):active:not(.btn-text),
  .btn.btn-outline-primary:not(:disabled):not(.disabled).active,
  .show > .btn.btn-outline-primary.dropdown-toggle,
  .show .btn.btn-outline-primary.btn-dropdown {
    background-color: #f3f6f9;
    border-color: #f3f6f9;
    color: #111;
  }
}
</style>
